"use strict";

exports.__esModule = true;
exports.NewLogbookCommentForm = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactFinalForm = require("react-final-form");
var _reactIntl = require("react-intl");
var _finalFormArrays = _interopRequireDefault(require("final-form-arrays"));
var _core = require("@blueprintjs/core");
var _DeviceListContext = require("../../Device/DeviceListContext");
var _LogbookContext = require("../../Logbook/LogbookContext");
var _DeviceSelector = require("../../Device/DeviceSelector");
var _FormGroupField = require("../../Form/FormGroupField");
var _Core = require("../../Core");
var _UI = require("../../../Utils/UI");
var _DefaultCommentSelector = require("../../UserActions/DefaultCommentSelector/DefaultCommentSelector");
var _PredefinedCommentsContext = require("../../PredefinedComments/PredefinedCommentsContext");
var _TicketingContext = require("../../Ticketing/TicketingContext");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var LogbookCommentFormContainer = _styledComponents["default"].div.withConfig({
  displayName: "NewLogbookCommentForm__LogbookCommentFormContainer",
  componentId: "sc-5dugj9-0"
})(["display:flex;flex:0 0 auto;height:100%;"]);
var DialogBodySection = _styledComponents["default"].div.withConfig({
  displayName: "NewLogbookCommentForm__DialogBodySection",
  componentId: "sc-5dugj9-1"
})(["margin:1rem 1rem 0 1rem;"]);
var validateComment = function validateComment(value) {
  if (!value || !value.trim()) {
    return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "NewLogbookComment.commentError",
      defaultMessage: "Comment is required."
    });
  }
};
var validateDevices = function validateDevices(value) {
  if (!Array.isArray(value) || value.length === 0) {
    return /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "NewLogbookComment.deviceError",
      defaultMessage: "Device is required."
    });
  }
};
var getDefaultInitialComment = function getDefaultInitialComment(defaultCommentID, defaultComments) {
  if (defaultCommentID) {
    var initialDefaultComment = defaultComments.find(function (defaultComment) {
      return defaultComment._id === defaultCommentID;
    });
    return initialDefaultComment || {};
  } else {
    return {};
  }
};
var NewLogbookCommentForm = exports.NewLogbookCommentForm = function NewLogbookCommentForm(props) {
  var onClose = props.onClose,
    showCancel = props.showCancel,
    useTicketingContext = props.useTicketingContext,
    device = props.device,
    defaultCommentID = props.defaultCommentID;
  var context = useTicketingContext ? _react["default"].useContext(_TicketingContext.TicketingContext) : _react["default"].useContext(_LogbookContext.LogbookContext);
  var devices = _react["default"].useContext(_DeviceListContext.DeviceListContext);
  var _React$useContext = _react["default"].useContext(_PredefinedCommentsContext.PredefinedCommentsContext),
    defaultComments = _React$useContext.settings.defaultComments;
  var _useState = (0, _react.useState)(getDefaultInitialComment(defaultCommentID, defaultComments)),
    defaultComment = _useState[0],
    setDefaultComment = _useState[1];
  var _useState2 = (0, _react.useState)(""),
    commentValue = _useState2[0],
    setCommentValue = _useState2[1];
  var _React$useContext2 = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext2.translate;
  var _onSelect = function onSelect(selectedDefaultComment, commentInput) {
    var selectedCommentContent = selectedDefaultComment[0];
    validateComment(selectedCommentContent == null ? void 0 : selectedCommentContent.comment);
    if (commentInput !== "" && (defaultComment == null ? void 0 : defaultComment.comment) !== commentInput) {
      (0, _UI.showWarningToaster)(translate("NewLogbookComment.create.warning", "The default comment was edited. Are you sure to override changes?"), {
        onClick: function onClick() {
          if (defaultComment === selectedCommentContent) {
            setDefaultComment({});
            setCommentValue("");
          } else {
            setDefaultComment(selectedCommentContent);
            setCommentValue(selectedCommentContent == null ? void 0 : selectedCommentContent.comment);
          }
        },
        text: "Change"
      });
    } else {
      setDefaultComment(selectedCommentContent);
    }
  };
  var handleCommentSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(values) {
      var devices, output;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            devices = values.devices.map(function (device) {
              return {
                type: "UUID",
                value: device.uuid
              };
            });
            output = {
              author: "",
              body: values.comment,
              entity: "device",
              devices: devices,
              interval: {
                startMillis: 1540504041436,
                endMillis: 1540504041437
              }
            };
            _context.n = 1;
            return context.createNewComment(output);
          case 1:
            if (onClose) {
              onClose();
            }
          case 2:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleCommentSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(LogbookCommentFormContainer, null, /*#__PURE__*/_react["default"].createElement(_reactFinalForm.Form, {
    initialValues: {
      devices: device ? [device] : [],
      comment: commentValue || (defaultComment == null ? void 0 : defaultComment.comment)
    },
    onSubmit: handleCommentSubmit,
    mutators: Object.assign({}, _finalFormArrays["default"])
  }, function (_ref2) {
    var handleSubmit = _ref2.handleSubmit,
      invalid = _ref2.invalid,
      submitting = _ref2.submitting,
      values = _ref2.values;
    return /*#__PURE__*/_react["default"].createElement("form", {
      style: {
        width: "100%"
      },
      onSubmit: handleSubmit
    }, /*#__PURE__*/_react["default"].createElement(DialogBodySection, null, defaultComments && (defaultComments == null ? void 0 : defaultComments.length) !== 0 && /*#__PURE__*/_react["default"].createElement(_DefaultCommentSelector.DefaultCommentSelector, {
      style: {
        marginBottom: "10px"
      },
      selected: defaultComment != null && defaultComment.comment ? [defaultComment] : [],
      toggle: true,
      onSelect: function onSelect(value) {
        return _onSelect(value, values.comment);
      },
      items: defaultComments
    }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "comment",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "NewLogbookTicket.comment",
        defaultMessage: "Comment"
      }),
      validate: validateComment
    }, function (_ref3) {
      var input = _ref3.input;
      return /*#__PURE__*/_react["default"].createElement(_core.TextArea, _extends({
        "data-testid": "CommentTextArea",
        fill: true,
        style: {
          height: "100px"
        },
        onSelect: function onSelect(e) {
          setCommentValue(e.target.value);
        }
      }, input));
    }), /*#__PURE__*/_react["default"].createElement(_FormGroupField.FormGroupField, {
      name: "devices",
      label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "NewLogbookTicket.deviceSelector",
        defaultMessage: "Devices"
      }),
      validate: validateDevices
    }, function (_ref4) {
      var input = _ref4.input;
      return /*#__PURE__*/_react["default"].createElement(_DeviceSelector.DeviceSelector, _extends({
        usePortal: false,
        minimal: true
      }, input, {
        items: devices,
        selected: input.value,
        onSelect: input.onChange,
        multiple: true
      }));
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.DIALOG_FOOTER
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _core.Classes.DIALOG_FOOTER_ACTIONS
    }, showCancel ? /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "LogbookCommentFormCancel",
      onClick: onClose,
      intent: _core.Intent.NONE,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "Ticketing.Cancel",
        defaultMessage: "Cancel"
      })
    }) : null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
      "data-testid": "LogbookCommentFormSubmit",
      type: "submit",
      intent: _core.Intent.PRIMARY,
      loading: submitting,
      text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
        id: "NewLogbookComment.create.button.comment",
        defaultMessage: "Create Comment"
      }),
      disabled: invalid
    }))));
  }));
};